import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import SearchBar from './SearchBar'
import List from './List'
import Store from './store.js'
import { Provider } from 'mobx-react'
import { Link } from 'react-router'
import { EXPERIENCE_SHOP_COOP_MANAGE } from '@constant'

export default class extends Component {
  constructor(props) {
    super(props)

    this.store = new Store()
  }

  render() {
    const header = [
      <Link to={EXPERIENCE_SHOP_COOP_MANAGE}>合作账户管理</Link>,
      '历史月度账单'
    ]

    return (
      <Provider store={this.store}>
        <HeaderView header={header} title="服务费对账单">
          <SearchBar />
          <List />
        </HeaderView>
      </Provider>
    )
  }
}
